export const generateColors = (values: number[], baseColor: string): string[] => {
  const total = values.length

  const hexToRgb = (hex: string) => {
    let r = 0
    let g = 0
    let b = 0

    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16)
      g = parseInt(hex[2] + hex[2], 16)
      b = parseInt(hex[3] + hex[3], 16)
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16)
      g = parseInt(hex[3] + hex[4], 16)
      b = parseInt(hex[5] + hex[6], 16)
    }

    return {
      r,
      g,
      b,
    }
  }

  const {
    r,
    g,
    b,
  } = hexToRgb(baseColor)

  return values.map((_, index) => {
    const alpha = 1 - (index / total) * 0.7
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  })
}

export const reduceOpacity = (hex: string, percent: number): string => {
  // Remove leading # if present
  hex = hex.replace(/^#/, '')

  // Expand shorthand hex (#f00 → #ff0000)
  if (hex.length === 3) {
    hex = hex.split('').map(x => x + x)
      .join('')
  }

  // Convert to RGB values
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  // percent is already 0–1
  const alpha = Math.max(0, Math.min(1, percent))

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
